import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import ArticleCards from './components/ArticleCards';
import CategoryGrid from './components/CategoryGrid';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import JsonLd from '@/components/base/JsonLd';
import { SITE_URL } from '@/constants';

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      name: 'Superbuy Spreadsheet',
      url: SITE_URL,
      description: 'Discover the best Superbuy Spreadsheet resources for 2026. Explore organized product finds, QC guides, shipping tips, comparisons, and expert shopping tutorials.',
      potentialAction: {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: SITE_URL + '/?s={search_term_string}',
        },
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'WebPage',
      name: 'Superbuy Spreadsheet 2026 - Ultimate Finds, Guides & Shopping Resources',
      description: 'Discover the best Superbuy Spreadsheet resources for 2026. Explore organized product finds, QC guides, shipping tips, comparisons, and expert shopping tutorials. Your independent guide to smarter online shopping.',
      url: SITE_URL + '/',
      isPartOf: {
        '@type': 'WebSite',
        name: 'Superbuy Spreadsheet',
        url: SITE_URL,
      },
      about: {
        '@type': 'Thing',
        name: 'Superbuy Spreadsheet',
        description: 'An independent educational resource for organized online shopping, providing curated product category navigation, guides, and tools for smarter purchasing decisions.',
      },
      publisher: {
        '@type': 'Organization',
        name: 'Superbuy Spreadsheet',
        url: SITE_URL,
        logo: {
          '@type': 'ImageObject',
          url: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/67defc9f4dfae2c04004e8ea78b88107.png',
        },
      },
    },
  ],
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={homeSchema} />
      <Navbar />
      <main>
        <Hero />
        <About />
        <CategoryGrid />
        <ArticleCards />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}